import React, { useEffect, useCallback, useRef } from 'react';
import loadScript from 'app/libs/loadScript';

function ReCaptcha({ id = null, onSuccess, onError = undefined, onExpired, sitekey = process.env.REACT_APP_KEY_GOOGLE_RE_CAPTCHA }) {
	const isInit = useRef(false);
	const captchaContainer = useRef(null);

	const renderReCaptcha = useCallback(() => {
		const options = {
			sitekey,
			callback: 'recaptchaSuccess',
			'error-callback': 'recaptchaError',
			'expired-callback': 'recaptchaExpired',
		};
		isInit.current = true;
		window.grecaptcha.render(captchaContainer.current, options);
	}, [isInit, sitekey]);

	useEffect(() => {
		if (id && window.grecaptcha) {
			if (isInit.current) {
				window.grecaptcha.reset();
			} else {
				renderReCaptcha();
			}
		}
	}, [id, renderReCaptcha]);

	useEffect(() => {
		window.onloadReCaptchaCallback = () => {
			renderReCaptcha();
		};

		loadScript('google-recaptcha', 'https://www.google.com/recaptcha/api.js?onload=onloadReCaptchaCallback&render=explicit');

		return () => {
			if (window.onloadReCaptchaCallback) delete window.onloadReCaptchaCallback;
		};
	}, [renderReCaptcha]);

	useEffect(() => {
		window.recaptchaSuccess = (key) => onSuccess && onSuccess(key);
		window.recaptchaError = () => onError && onError();
		window.recaptchaExpired = () => onExpired && onExpired();

		return () => {
			if (window.recaptchaSuccess) delete window.recaptchaSuccess;
			if (window.recaptchaError) delete window.recaptchaError;
			if (window.recaptchaExpired) delete window.recaptchaExpired;
		};
	}, [onSuccess, onError, onExpired]);

	return (
		<div
			className="g-recaptcha"
			ref={captchaContainer}
		/>
	);
}

export default ReCaptcha;
